import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["links", "title", "as", "pageType", "slug", "url", "contentProps"];
import React from 'react';
import { Menu } from 'semantic-ui-react';
import DropdownMenu from './DropdownMenuItems';
import Link from '../../../atoms/Link';
import { isExternalPage } from '../../../services/pages';
export default (function (_ref) {
  var links = _ref.links,
    linksAs = _ref.linksAs;
  return links.map(function (link) {
    var linkOptions = link.links,
      title = link.title,
      as = link.as,
      pageType = link.pageType,
      slug = link.slug,
      url = link.url,
      contentProps = link.contentProps,
      rest = _objectWithoutProperties(link, _excluded);
    if (linkOptions) {
      return /*#__PURE__*/React.createElement(DropdownMenu, {
        title: title,
        options: linkOptions,
        linksAs: linksAs
      });
    }
    return /*#__PURE__*/React.createElement(Menu.Item, {
      link: true,
      key: link.title
    }, /*#__PURE__*/React.createElement(Link, _extends({
      to: isExternalPage(pageType) ? url : slug,
      linkAs: as || linksAs,
      title: title,
      internal: !isExternalPage(pageType),
      contentProps: contentProps
    }, rest)));
  });
});